import { IconDefinition } from "@fortawesome/fontawesome-svg-core";
import { faRocket } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ConfigProvider, Tabs } from "antd";
import { useContext } from "react";
import CatalogBrowserContext, { useEditorSidebarTabKey } from "./CatalogBrowserContext";

type Props = {
  listLabel: string
  listIcon: IconDefinition
}

/**
 * The tab bar at the top of a full-page editor drawer's sidebar: the drawer's own
 * list, and the Catalog Browser. The active tab follows CatalogBrowserContext.
 */
const EditorSidebarTabs = ({ listLabel, listIcon }: Props) => {
  const { isCatalogBrowserOpen, toggleCatalogBrowser } = useContext(CatalogBrowserContext)
  const selectedKey = useEditorSidebarTabKey()

  return <ConfigProvider
    theme={{
      components: {
        Tabs: {
          itemColor: '#7a7a7a',
          itemSelectedColor: '#ff5c00',
          inkBarColor: '#ff5c00',
        }
      }
    }}
  >
    <Tabs
      activeKey={selectedKey}
      onChange={key => {
        if ((key === 'item-catalog' && !isCatalogBrowserOpen)
          || (key === 'list' && isCatalogBrowserOpen)) {
          toggleCatalogBrowser()
        }
      }}
      tabBarGutter={8}
      tabPosition="top"
      items={[
        {
          key: 'list',
          label: (
            <div style={tabStyle(selectedKey === 'list')}>
              <FontAwesomeIcon icon={listIcon} />
              <span style={{ marginLeft: 8 }}>{listLabel}</span>
            </div>
          )
        },
        {
          key: 'item-catalog',
          label: (
            <div style={tabStyle(selectedKey === 'item-catalog')}>
              <FontAwesomeIcon icon={faRocket} />
              <span style={{ marginLeft: 8 }}>Catalog Browser</span>
            </div>
          )
        }
      ]}
      moreIcon={null}
      renderTabBar={(props, DefaultTabBar) => (
        <div style={{
          display: 'flex',
          width: '100%',
          padding: '0 24px',
          background: '#ffffff',
          height: '64px',
          alignItems: 'baseline',
          justifyContent: 'center'
        }}>
          <DefaultTabBar {...props} />
        </div>
      )}
    />
  </ConfigProvider>
}

export default EditorSidebarTabs

const tabStyle = (isActive: boolean): React.CSSProperties => ({
  display: 'flex',
  alignItems: 'center',
  padding: '8px 20px',
  backgroundColor: isActive ? '#ff5c00' : '#ffffff',
  color: isActive ? '#ffffff' : '#7a7a7a',
  fontWeight: 500,
  borderRadius: '12px',
  border: 'none',
  position: 'relative',
  transition: 'all 0.3s ease',
  boxShadow: isActive ? '0 2px 4px rgba(0, 0, 0, 0.1)' : 'none'
});
